import { SELECTION_STAGES, STAGE_LABELS, type SelectionStage } from '@shared/types/room';

export function StepProgress({ stage }: { stage: SelectionStage }) {
  const index = SELECTION_STAGES.indexOf(stage);
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between text-sm">
        <span className="font-bold tracking-wide text-primary-600">
          STEP {index + 1} / {SELECTION_STAGES.length}
        </span>
        <span className="text-charcoal-500">{STAGE_LABELS[stage].progress}</span>
      </div>
      <ol className="flex gap-1.5" aria-label="진행 단계">
        {SELECTION_STAGES.map((s, i) => (
          <li
            key={s}
            className={`h-2 flex-1 rounded-full transition-colors duration-300 ${i < index ? 'bg-primary-300' : i === index ? 'bg-primary-500' : 'bg-cream-300'}`}
            aria-current={i === index ? 'step' : undefined}
            aria-label={`${i + 1}단계 ${STAGE_LABELS[s].title}`}
          />
        ))}
      </ol>
    </div>
  );
}
